import { connect } from 'react-redux';

import { getActiveScriptId, getDeleteModal } from 'current/selectors';
import { closeDeleteModal } from 'current/uiwidgets/';
import { deleteScriptViaScriptManagement } from 'scripts';

import DeleteModal from './DeleteModal';

export default connect(
  (state) => {
    return {
      deleteModal: getDeleteModal(state),
      scriptId: getActiveScriptId(state)
    };
  },
  (dispatch) => {
    return {
      onCancelDeleteModal: () => {
        dispatch(closeDeleteModal());
      },
      onSaveDeleteModal: ({ scriptId }) => {
        dispatch(deleteScriptViaScriptManagement({ scriptId }));
      }
    };
  }
)(DeleteModal);

